import { NOW, REGEX } from 'context/DateProvider/DateProvider';

enum GRANULARITY {
  MINUTE = 'm',
  HOUR = 'h',
  DAY = 'd',
}

const minuteConversions: Record<GRANULARITY, number> = {
  [GRANULARITY.MINUTE]: 1,
  [GRANULARITY.HOUR]: 60,
  [GRANULARITY.DAY]: 1440,
};

const getMinutes = (granularity: GRANULARITY, number: string): number => {
  const multiplier = minuteConversions[granularity] ?? 0;
  return parseInt(number) * multiplier;
};

export const convertNowToISO = (nowValue: string): string => {
  const nowAsDate = new Date();

  if (nowValue === NOW) {
    return nowAsDate.toISOString();
  }

  const match = nowValue.match(REGEX);
  if (match) {
    // 0 element in destructure would be the full match
    const [, operator, number, granularity] = match;
    const minutes = getMinutes(granularity as GRANULARITY, number);

    nowAsDate.setMinutes(nowAsDate.getMinutes() + (operator === '+' ? minutes : -minutes));

    return nowAsDate.toISOString();
  }

  return nowValue;
};
